import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OutboundTranscription, OutboundTranscriptionMessage } from 'types/outbound';

const initialState: {
  liveTranscriptions: Record<string, Record<string, OutboundTranscriptionMessage>>;
  transcriptions: Record<string, OutboundTranscription>;
} = {
  liveTranscriptions: {},
  transcriptions: {},
};

const transcriptionSlice = createSlice({
  name: 'transcription',
  initialState,
  reducers: {
    setTranscription: (state, action: PayloadAction<OutboundTranscription>) => {
      state.transcriptions[action.payload.dialTaskId] = action.payload;
    },
    setTranscriptionMessage: (
      state,
      action: PayloadAction<OutboundTranscriptionMessage>,
    ) => {
      const existing =
        state.liveTranscriptions?.[action.payload.transcription.dialTaskId] ?? {};

      state.liveTranscriptions[action.payload.transcription.dialTaskId] = {
        ...existing,
        [action.payload.id]: action.payload,
      };
    },
  },
});

export const { setTranscriptionMessage, setTranscription } = transcriptionSlice.actions;

export default transcriptionSlice.reducer;
